import { useDispatch, useSelector } from "react-redux";
import {
  filterVideoLibraryDataTable,
  setSelectedVideoPath,
  setVideoLibraryTableStateByName,
} from "../../../../Redux/Actions/VideoLibraryDataTableActions";
import TableRow from "./TableRow";
import styles from "./table.module.css";
import ColumnFilterTooltip from "./ColumnFilterTooltip/ColumnFilterTooltip";
import { useEffect, useCallback, useState } from "react";
import { setFilterValues } from "../../../../Redux/Actions/VideoLibraryFilterAction";
import ShareVideo from "../Content/ShareVideo";
import { eventConstants } from "../../../../utils/constant";

const DataTable = ({
  setPlaying,
  memoizedState,
  currentVideoIndex,
  setCurrentVideoIndex,
}) => {
  const {
    InSeason,
    Game,
    Practice,
    OpponentScout,
    OffSeason,
    Other,
    inSeason,
    offSeason,
    other,
    game,
    smallPractice,
    opponentScout,
  } = eventConstants;
  const dispatch = useDispatch();
  const { isTableDisabled, tableData, filteredTableData, isTableEditable } =
    useSelector((state) => state?.VideoLibraryDataTable);
  const activeBreakDownList = tableData?.[0]?.row;
  const breakDownnTableData = filteredTableData ? filteredTableData : tableData;
  const checkActiveRow = (item) => {
    return item.row.some((item) => item?.focus) ? styles.activeRow : "";
  };

  const modifiedActiveBreakDownList = activeBreakDownList?.map((item) => {
    const valuesCountMap = {};

    const filteredValues = tableData
      .flatMap((tempItem) => tempItem.row)
      .filter(
        (rowItem) => rowItem.id === item.id && rowItem.value.trim() !== ""
      )
      .map((rowItem) => {
        const { value, mediaBreakdownId } = rowItem;
        valuesCountMap[value] = (valuesCountMap[value] || 0) + 1;
        return { value, mediaBreakdownId };
      });

    const totalValues = filteredValues.length;
    const uniqueValues = [
      ...new Map(filteredValues.map((item) => [item.value, item])).values(),
    ];

    const valuesWithPercentage = uniqueValues.map((value) => {
      const count = valuesCountMap[value.value] || 0;
      const percentage = ((count / totalValues) * 100).toFixed(0);
      return {
        value: value.value,
        percentage,
        count,
        mediaBreakdownId: value?.mediaBreakdownId,
      };
    });

    return {
      breakDownName: item?.breakdownName,
      id: item.id,
      values: valuesWithPercentage,
    };
  });

  useEffect(() => {
    return () => {
      filterVideoLibraryDataTable(dispatch, []);
      setFilterValues(dispatch, []);
    };
  }, []);

  const changeRowColumn = useCallback(
    (tableItemIndex, index) => {
      setVideoLibraryTableStateByName(dispatch, {
        breakDownId: breakDownnTableData[tableItemIndex]?.id,
        rowId: breakDownnTableData[tableItemIndex]?.row[index]?.id,
        changes: { focus: true, isEditable: true },
        table:
          filteredTableData?.length > 0 ? "filteredTableData" : "tableData",
      });
    },
    [breakDownnTableData]
  );

  const setTableState = useCallback((changes, tableItemIndex, index) => {
    setVideoLibraryTableStateByName(dispatch, {
      breakDownId: breakDownnTableData[tableItemIndex]?.id,
      rowId: breakDownnTableData[tableItemIndex]?.row[index]?.id,
      changes,
      table: filteredTableData?.length > 0 ? "filteredTableData" : "tableData",
    });
  }, []);

  useEffect(() => {
    const resizeHandles = document.querySelectorAll(".resize-handle");
    let resizing = false;
    let startX = 0;
    let initialWidth = 0;
    let columnIndex = 0;

    function startResize(event) {
      event.preventDefault();
      const isTouch = event.type === "touchstart";
      const e = isTouch ? event.touches[0] : event;

      resizing = true;
      const th = e.target.parentElement;
      columnIndex = Array.from(th.parentElement.children).indexOf(th) + 1;
      startX = e.pageX;
      initialWidth = th.offsetWidth;
    }

    function onResize(event) {
      if (!resizing) return;
      const isTouch = event.type === "touchmove";
      const e = isTouch ? event.touches[0] : event;

      const offset = e.pageX - startX;
      const newWidth = initialWidth + offset;
      if (newWidth > 0) {
        const table = document.getElementById("customers");
        table.style.width = "";
        table.style.width = table.offsetWidth + offset + "px";
        const th = document.querySelector(`th:nth-child(${columnIndex})`);
        th.style.width = newWidth + "px";
      }
    }

    function stopResize() {
      resizing = false;
    }

    resizeHandles.forEach((handle) => {
      handle.addEventListener("mousedown", startResize);
      handle.addEventListener("touchstart", startResize, { passive: false });
    });

    document.addEventListener("mousemove", onResize);
    document.addEventListener("touchmove", onResize, { passive: false });
    document.addEventListener("mouseup", stopResize);
    document.addEventListener("touchend", stopResize);

    return () => {
      document.removeEventListener("mousemove", onResize);
      document.removeEventListener("touchmove", onResize);
      document.removeEventListener("mouseup", stopResize);
      document.removeEventListener("touchend", stopResize);
    };
  }, []);

  return (
    <div
      className={`position-relative dataTableContainer ${
        memoizedState.isTableEditable && "borderActive"
      }`}
    >
      {activeBreakDownList?.length > 0 && (
        <div className="bottomContent position-relative">
          <table
            id="customers"
            className={`fs-16 h-100 ${isTableDisabled && "disabledTable"}`}
          >
            <thead>
              {activeBreakDownList?.length > 0 && (
                <tr className={`tableHeadings`}>
                  <th className={styles.playColumn}>Action</th>
                  <th className={styles.playColumn}>Play</th>
                  {modifiedActiveBreakDownList?.map((item, index) => (
                    <th key={item.id} className="position-relative">
                      <ColumnFilterTooltip key={item.id} item={item} />
                      <div className={`resize-handle ${styles.resizeHandle}`} />
                    </th>
                  ))}
                </tr>
              )}
            </thead>
            <tbody className="fs-16">
              {breakDownnTableData?.map((item, index) => (
                <tr
                  key={item.id}
                  className={`fs-16 ${checkActiveRow(item)} ${
                    styles.tableRowHover
                  }`}
                  onClick={() => {
                    setSelectedVideoPath(dispatch, {
                      id: item?.id,
                      videoPath: item?.eventMedia?.videoPath,
                    });
                    setPlaying(true);
                    //setCurrentVideoIndex(index);
                  }}
                  // onMouseEnter={() => handleMouseEnter(item, index)}
                  // onMouseLeave={() => handleMouseLeave(item, index)}
                >
                  <td>
                    <div className="tableVideoList">
                      <div
                        className={`oflow-hidden mnl25 ${styles.playColumn}`}
                      >
                        <ShareVideo
                          eventMediaId={item?.id}
                          playlistId={item?.eventMedia?.playlist?.id}
                          videoPath={item?.eventMedia?.videoPath}
                          videoName={item?.eventMedia?.eventMediaCategory}
                          seasonName={item?.event?.season?.years}
                          seasonType={
                            item?.event?.season?.seasonType === InSeason
                              ? inSeason
                              : item?.event?.season?.seasonType === OffSeason
                              ? offSeason
                              : item?.event?.season?.seasonType === Other
                              ? other
                              : null
                          }
                          eventType={
                            item?.event?.eventType === Game
                              ? game
                              : item?.event?.eventType === Practice
                              ? smallPractice
                              : item?.event?.eventType === OpponentScout
                              ? opponentScout
                              : null
                          }
                          offSeasonEventName={item?.event?.eventName}
                          practiceName={item?.event?.practiceName}
                          otherSeasonEventType={item?.event?.eventName}
                          videoData={item}
                          isVideoFromLibrary={true}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="tableVideoList">
                      <div className="oflow-hidden w-100">
                        <p className={`text-width-auto ${styles.videoName}`}>
                          {item.eventMedia.eventMediaCategory}
                          {/* {item.eventMedia.eventMediaCategory.length > 15
                            ? `${item.eventMedia.eventMediaCategory.slice(
                                0,
                                15
                              )}...`
                            : item.eventMedia.eventMediaCategory} */}
                        </p>
                      </div>
                    </div>
                  </td>
                  <TableRow
                    item={item}
                    tableItemIndex={index}
                    changeRowColumn={changeRowColumn}
                    setTableState={setTableState}
                    isTableEditable={isTableEditable}
                    setPlaying={setPlaying}
                  />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {filteredTableData?.length === 0 && (
        <div className="pd-10 text-center">
          <p className="semi-bold text-center fs-18">
            No Data Found For Applied Filter
          </p>
        </div>
      )}
    </div>
  );
};

export default DataTable;
